import reduceReducers from 'reduce-reducers';

//Siblings reducers
import packageReducer from './package-reducer';
import assessmentReducer from './assessment-reducer';

export default reduceReducers(packageReducer, assessmentReducer);
